<h2 class="faq-title">F.A.Q.</h2>
<mat-accordion class="mat-accordion">
  <mat-expansion-panel *ngFor="let faq of faqs">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ faq.question }}
      </mat-panel-title>
      <span class="custom-chevron">⌵</span>
    </mat-expansion-panel-header>
    <div class="faq-content">
      <markdown [data]="faq.answer"></markdown>
    </div>
  </mat-expansion-panel>
</mat-accordion>